import { useQuery } from '@tanstack/react-query'
import { getTimeBlocks } from '@lib/api'
import { timeBlockKeys } from '@lib/keys'

export const useTimeBlocks = (timeCardId = 0) => {
  return useQuery(
    timeBlockKeys.byTimeCard(timeCardId),
    () => getTimeBlocks(timeCardId),
    { enabled: timeCardId !== 0 },
  )
} 